export const UnitEnum = {
    EACH: 'each',
    PSC: 'psc',
} as const;

export type UnitType = (typeof UnitEnum)[keyof typeof UnitEnum];
